import { daysJsFormat, renderUserName } from "../../../utils/constants";
import { Button, Space, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "../../../utils/dayjs";
import { BiSearch } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";
import React from "react";
import { t } from "i18next";

export const columnsLogList = logs => {
  let uniquebaseUrl = [];

  if (logs !== false) {
    const uniqueValuesSet = new Set();

    logs.map(obj => {
      uniqueValuesSet.add(obj.baseUrl);
    });

    let array = [...uniqueValuesSet];

    array.map(o => {
      uniquebaseUrl.push({ text: o, value: o });
    });
  }

  let uniqueUser = logs
    .map(log => ({
      text: renderUserName(log?.user),
      value: log?.user?._id,
    }))
    .filter(
      (user, index, self) =>
        index ===
        self.findIndex(t => t.value === user.value && t.text === user.text),
    );

  return [
    {
      title: t("columnsLogList.date"),
      dataIndex: "createdAt",
      key: "createdAt",
      render: e => <span>{dayjs(e).format(daysJsFormat.full)}</span>,
      width: "15%",
      sorter: (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>{t("columnsLogList.tooltipResource")}</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            {t("columnsLogList.resource")}
          </>
        );
      },
      filters: uniquebaseUrl,
      onFilter: (value, record) => record.baseUrl.indexOf(value) === 0,
      dataIndex: "baseUrl",
      key: "baseUrl",
      width: "15%",
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>{t("columnsLogList.tooltipMethod")}</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            {t("columnsLogList.method")}
          </>
        );
      },
      dataIndex: "method",
      key: "method",
      filters: [
        { value: "POST", text: "POST" },
        { value: "PATCH", text: "PATCH" },
        { value: "DELETE", text: "DELETE" },
      ],
      onFilter: (value, record) => record.method.indexOf(value) === 0,
      width: "15%",
    },
    {
      title: () => {
        return (
          <>
            <Tooltip
              title={<span>{t("columnsLogList.tooltipItem")}</span>}
              placement={"right"}
            >
              <InfoCircleOutlined style={{ color: "white" }} />
            </Tooltip>{" "}
            {t("columnsLogList.itemLinked")}
          </>
        );
      },
      dataIndex: "entityId",
      render: entityId => <p>{entityId}</p>,
      key: "entityId",
      search: true,
      width: "15%",
    },
    {
      title: t("columnsLogList.route"),
      dataIndex: "route",
      render: route => <p>{route}</p>,
      key: "route",
      search: true,
      width: "15%",
    },
    {
      title: t("columnsLogList.user"),
      dataIndex: "user",
      key: "user",
      render: (user, record) => renderUserName(user),
      filters: uniqueUser,
      onFilter: (value, record) => {
        return record.user._id.indexOf(value) === 0;
      },
      width: "15%",
    },
  ];
};

export const inputsLogsList = ({
  searchState,
  setPagination,
  pagination,
  defaultPagination,
  loading,
  formRef,
  dispatchActionLogs,
  setSearchState,
}) => {
  return [
    {
      parentLabel: null,
      children: [
        {
          label: t("inputsLogsList.searchEntity"),
          name: "entityId",
          value: searchState.entityId,
          type: "input",
          col: 8,
        },
        {
          type: "component",
          style: { textAlign: "left" },
          xl: 7,
          lg: 7,
          md: 7,
          sm: 12,
          xs: 24,
          label: "",
          component: () => (
            <Space
              align={"center"}
              style={{ width: "100%", justifyContent: "flex-end" }}
            >
              <Button
                loading={loading}
                size={"middle"}
                type={"primary"}
                style={{
                  marginTop: "-6px",
                  width: "100%",
                  fontWeight: "bold",
                }}
                icon={<BiSearch style={{ marginTop: "0px" }} size={25} />}
                onClick={() => formRef.current.submit()}
              >
                {t("inputsLogsList.search")}
              </Button>
              <Button
                style={{
                  marginTop: "-7px",
                  width: "100%",
                  color: colorPrimary,
                  fontWeight: "bold",
                }}
                icon={<GrPowerReset style={{ marginTop: "-3px" }} size={15} />}
                onClick={async () => {
                  localStorage.removeItem("logsSearcher");

                  setSearchState({});

                  formRef.current.resetFields(); // Reset the form fields using the ref

                  formRef.current.setFieldsValue({
                    entityId: "",
                  });
                  setPagination(defaultPagination);
                  await dispatchActionLogs();
                }}
                size="middle"
                type={"text"}
              >
                {t("inputsLogsList.reset")}
              </Button>
            </Space>
          ),
        },
      ],
    },
  ];
};
